<template>
    <div class="land-video">
        <div class="video-items">
            <div class="video-item" v-for="item in salesCard.project_land_site.video_items">
                <!-- :to="'/news/' + cytTolat(item.title)" -->
                <a href="#" class="link-open-modal" @click.prevent="openVideoModal(item.video_link)">
                    <svg-icon icon-class="play" className="icon-play"/>
                    <div class="video-item-img">
                        <img :src="item.video_preview" alt="">
                    </div>
                </a>
            </div>
        </div>
        <modal name="video-modal" 
            @before-close="beforeVideoModalClose" 
            @closed="videoModalClosed" 
            :transition="transitionName" 
            :width="modalWidth" 
            :height="modalHeight" 
            :scrollable="modalScrollable"  
            class="video-item-modal"               
            id="video-modal">
            <div class="modal-content" v-if="modalData.link != null">
                <!-- <div class="video-date">
                    <span>{{correctDate(modalData.date)}}</span>
                </div>
                <div class="video-title">
                    <h2>{{modalData.title}}</h2>
                </div> -->
                <div class="video-player">
                    <iframe :src="modalData.link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                </div>
                <a href="#" class="close-link" @click.prevent="closeVideoModal">
                    <svg-icon icon-class="close" className="icon-close"/>
                </a>
            </div>
        </modal>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-video',
        components: {
        },
        data () {
            return {
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                modalData: {
                    // date: null,
                    // title: null,
                    link: null
                },
                transitionName: 'pop-out',
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
            cytTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8,10));
                var month = date.slice(5,7);
                var year = date.slice(0,4);
                var monthFont;
                var total;
                if (month == '01') {
                    monthFont = 'Января'
                } else if (month == '02') {
                    monthFont = 'Февраля'
                } else if (month == '03') {
                    monthFont = 'Марта'
                } else if (month == '04') {
                    monthFont = 'Апреля'
                } else if (month == '05') {
                    monthFont = 'Мая'
                } else if (month == '06') {
                    monthFont = 'Июня'
                } else if (month == '07') {
                    monthFont = 'Июля'
                } else if (month == '08') {
                    monthFont = 'Августа'
                } else if (month == '09') {
                    monthFont = 'Сентября'
                } else if (month == '10') {
                    monthFont = 'Октября'
                } else if (month == '11') {
                    monthFont = 'Ноября'
                } else if (month == '12') {
                    monthFont = 'Декабря'
                }
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
            openVideoModal(link) {
                // this.modalData.date = date;
                // this.modalData.title = title;
                this.modalData.link = link;
                this.$modal.show('video-modal');
                document.getElementsByTagName('body')[0].classList.add('video_open');
            },
            closeVideoModal() {
                this.$modal.hide('video-modal');
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            beforeVideoModalClose() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            videoModalClosed() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-video.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-video-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>